        import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  InputAdornment,
  Tooltip,
  CircularProgress,
  Alert,
  Snackbar,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  FormControlLabel,
  Switch,
  Checkbox,
  FormGroup,
} from "@mui/material";
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Search as SearchIcon,
  FilterList as FilterIcon,
  Clear as ClearIcon,
  AccountCircle as AccountCircleIcon,
  SmartToy as SmartToyIcon,
} from "@mui/icons-material";
import {
  getKeywords,
  addKeyword,
  updateKeyword,
  deleteKeyword,
  getFilteredKeywords,
} from "../../services/keywordService";
import { getAccountsByPlatform } from "../../services/socialMediaAccountsService";
import axios from "axios";
import { API_BASE_URL } from "../../services/api";

const TwitterKeywords = () => {
  // State for keywords data
  const [keywords, setKeywords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // State for Twitter accounts
  const [twitterAccounts, setTwitterAccounts] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [loadingAccounts, setLoadingAccounts] = useState(false);
   const [isFilteringEnabled, setIsFilteringEnabled] = useState(false);
   const [filterOptions, setFilterOptions] = useState({
      excludePromotional: true,
      excludeWithLinks: false,
      enableCustomRule: false,
      customRuleText: "",
    });
 
  const [selectedKeywordPrompt, setSelectedKeywordPrompt] = useState(null);

  // State for prompt management
  const [promptManagementOpen, setPromptManagementOpen] = useState(false);
  const [keywordForPrompt, setKeywordForPrompt] = useState(null);
const [availableModels, setAvailableModels] = useState([
    { id: "gemini-2.5-flash", name: "gemini-2.5-flash", selected: true },
    { id: "gemini-2.5-flash-lite", name: "gemini-2.5-flash-lite", selected: false },
    { id: " gemini-2.5-pro", name: "  gemini-2.5-pro", selected: false },
  ]);
  const [selectedModel, setSelectedModel] = useState("gemini-2.5-flash");
  
  const [availablePrompts, setAvailablePrompts] = useState([]);
  const [selectedPrompt, setSelectedPrompt] = useState("default");
  const [customPrompt, setCustomPrompt] = useState("");
  const [isCustomPrompt, setIsCustomPrompt] = useState(false);
  const [editedPreviewContent, setEditedPreviewContent] = useState("");
  const [isPreviewEdited, setIsPreviewEdited] = useState(false);
// Remove debug console log
  // State for form
    const [fillterationPrompt,setFillterationPrompt]=useState("")
  const [formOpen, setFormOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [currentKeyword, setCurrentKeyword] = useState({
    id: null,
    text: "",
    minLikes: 0,
    minRetweets: 0,
    minFollowers: 0,
    accountId: null,
    promptId: null,
  });

  // State for delete confirmation
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [keywordToDelete, setKeywordToDelete] = useState(null);

  // State for filtering
  const [filters, setFilters] = useState({
    text: "",
    minLikes: "",
    minRetweets: "",
    minFollowers: "",
    accountId: "",
  });

  // State for notifications
  const [notification, setNotification] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  // We'll no longer use mock data as we have real API endpoints

  // Fetch keywords on component mount
  useEffect(() => {
    fetchKeywords();
    fetchTwitterAccounts();
    fetchAllPrompts(); // Fetch all prompts on component mount
  
    // Set up an interval to refresh prompts every 30 seconds
    const promptRefreshInterval = setInterval(() => {
      console.log("Refreshing prompts from backend...");
      fetchAllPrompts();
    }, 30000);
    
    // Clean up the interval when the component unmounts
    return () => clearInterval(promptRefreshInterval);
  }, []);
  
  // Set default prompt for a keyword (no API call to fetch associated prompts)
  const setDefaultPromptForKeyword = () => {
    // Just use the first available prompt as default
    if (availablePrompts.length > 0) {
      const defaultPrompt = availablePrompts.find(p => p.id === "default") || availablePrompts[0];
      setSelectedPrompt(defaultPrompt.id);
      setEditedPreviewContent(defaultPrompt.content);
      setIsPreviewEdited(false);
      
      // If the prompt has a model specified, use it
      if (defaultPrompt.model) {
        setSelectedModel(defaultPrompt.model);
      }
      
      return defaultPrompt.id;
    }
    return null;
  };
  
const fetchAllPrompts = () => {
  const defaultPrompts = [
    {
      id: "default",
      name: "Default",
      content: `Reply smartly to this tweet:\n"{tweetContent}".\nMake it personal, friendly, and relevant. Be professional and do not use emojis and crisp and small contents`,
      model: "gemini-2.5-flash"
    },
    {
      id: "professional",
      name: "Professional",
      content: `Craft a professional response to this tweet:\n"{tweetContent}".\nUse formal language, be concise, and maintain a business-appropriate tone.`,
      model: "gemini-2.5-flash"
    },
    {
      id: "engaging",
      name: "Engaging",
      content: `Create an engaging reply to this tweet:\n"{tweetContent}".\nAsk a thoughtful question to encourage further conversation while being relevant to the original content.`,
      model: "gemini-2.5-flash"
    },
    {
      id: "supportive",
      name: "Supportive",
      content: `Write a supportive response to this tweet:\n"{tweetContent}".\nShow empathy, offer encouragement, and be positive while keeping it brief and genuine.`,
      model: "gemini-2.5-flash"
    }
  ];

  setAvailablePrompts(defaultPrompts);
  console.log(`Using ${defaultPrompts.length} default prompts`);
  
  return true;
};

  

  
  // Fetch keywords when selected account changes
  useEffect(() => {
    fetchKeywords();
  }, [selectedAccount]);

  // Fetch Twitter accounts
  const fetchTwitterAccounts = async () => {
    setLoadingAccounts(true);
    try {
      const token = localStorage.getItem("token");
      const response = await getAccountsByPlatform("twitter", token);
      setTwitterAccounts(response.data || []);
    } catch (err) {
      console.error("Error fetching Twitter accounts:", err);
      setTwitterAccounts([]);
    } finally {
      setLoadingAccounts(false);
    }
  };

  // Fetch all keywords
  const fetchKeywords = async () => {
    setLoading(true);
    setError(null);
    try {
      const token = localStorage.getItem("token");
      const response = await getKeywords(selectedAccount, token);
      setKeywords(response.data || []);
    } catch (err) {
      setError("Failed to fetch keywords. Please try again later.");
      console.error("Error fetching keywords:", err);
      setKeywords([]);
    } finally {
      setLoading(false);
    }
  };

  // Apply filters
  const applyFilters = async () => {
    setLoading(true);
    setError(null);
    try {
      const token = localStorage.getItem("token");
      // Include the selected account in the filters if one is selected
      const filtersWithAccount = {
        ...filters,
        accountId: selectedAccount || filters.accountId,
      };
      const response = await getFilteredKeywords(filtersWithAccount, token);
      setKeywords(response.data || []);
    } catch (err) {
      setError("Failed to apply filters. Please try again later.");
      console.error("Error applying filters:", err);
    } finally {
      setLoading(false);
    }
  };

  // Clear filters
  const clearFilters = () => {
    setFilters({
      text: "",
      minLikes: "",
      minRetweets: "",
      minFollowers: "",
      accountId: "",
    });
    // Keep the selected account filter when clearing other filters
    fetchKeywords();
  };

  // Handle account change
  const handleAccountChange = (accountId) => {
    setSelectedAccount(accountId);
    // Refresh keywords for the selected account will happen via useEffect
  };

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCurrentKeyword({
      ...currentKeyword,
      [name]: name === "text" || name === "accountId" ? value : Number(value),
    });
  };

  // Handle filter input changes
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({
      ...filters,
      [name]: value,
    });
  };

  // Open form for adding new keyword
  const handleAddKeyword = () => {
    setCurrentKeyword({
      id: null,
      text: "",
      minLikes: 0,
      minRetweets: 0,
      minFollowers: 0,
      accountId: selectedAccount,
    });
    setIsEditing(false);
    setFormOpen(true);
  };

  // Open form for editing keyword
  const handleEditKeyword = (keyword) => {
    setCurrentKeyword({
      id: keyword.id,
      text: keyword.text,
      minLikes: keyword.minLikes,
      minRetweets: keyword.minRetweets,
      minFollowers: keyword.minFollowers,
      accountId: keyword.accountId,
      promptId: null, // No need to populate from API
    });
    setIsEditing(true);
    setFormOpen(true);
    
    // Set default prompt without fetching from API
    const promptId = setDefaultPromptForKeyword();
    setSelectedKeywordPrompt(promptId);
  };

  // Open delete confirmation dialog
  const handleDeleteClick = (id) => {
    setKeywordToDelete(id);
    setDeleteDialogOpen(true);
  };

  // Submit form for add/edit
  const handleSubmit = async () => {
    if (!currentKeyword.text.trim()) {
      setNotification({
        open: true,
        message: "Keyword text is required",
        severity: "error",
      });
      return;
    }

    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      
      // Split the keyword text by commas and trim whitespace
      // Note: When these keywords are used in search, they will be treated as a group
      // The Dashboard component will URL encode them to preserve the commas
      const keywordTexts = currentKeyword.text.split(',').map(keyword => keyword.trim()).filter(keyword => keyword !== '');
      
      // If editing, just update the single keyword
      if (isEditing) {
        // Create a copy of the keyword data with accountId converted to number if it exists
        const keywordData = {
          ...currentKeyword,
          // Make sure accountId is properly converted to a number or set to null if empty string
          accountId: currentKeyword.accountId ? Number(currentKeyword.accountId) : null,
          // Remove any promptId reference
          promptId: undefined
        };

        console.log('Updating keyword with data:', keywordData);
        await updateKeyword(currentKeyword.id, keywordData, token);
      } else {
        // Check if there are multiple keywords (comma-separated)
        if (keywordTexts.length > 1) {
          // If multiple keywords, add them as a single group
          const groupKeywordData = {
            text: currentKeyword.text, // Keep the original comma-separated text
            minLikes: currentKeyword.minLikes || 0,
            minRetweets: currentKeyword.minRetweets || 0,
            minFollowers: currentKeyword.minFollowers || 0,
            accountId: currentKeyword.accountId ? Number(currentKeyword.accountId) : null
          };
          
          console.log('Submitting keyword group with data:', groupKeywordData);
          try {
            const response = await addKeyword(groupKeywordData, token);
            console.log('Keyword group added successfully:', response);
          } catch (addError) {
            console.error('Error adding keyword group:', addError);
            throw addError;
          }
        } else {
          // For single keywords, add them individually
          for (const keywordText of keywordTexts) {
            const keywordData = {
              text: keywordText,
              minLikes: currentKeyword.minLikes || 0,
              minRetweets: currentKeyword.minRetweets || 0,
              minFollowers: currentKeyword.minFollowers || 0,
              accountId: currentKeyword.accountId ? Number(currentKeyword.accountId) : null
            };

            console.log('Submitting single keyword with data:', keywordData);
            try {
              const response = await addKeyword(keywordData, token);
              console.log('Keyword added successfully:', response);
            } catch (addError) {
              console.error('Error adding keyword:', addError);
              throw addError;
            }
          }
        }
      }

      // Refresh the keywords list
      await fetchKeywords();

      // Adjust the success message based on whether we're adding a group or individual keywords
      // Use the existing keywordTexts variable that was declared earlier
      const keywordCount = !isEditing ? keywordTexts.length : 1;
      
      let successMessage;
      if (isEditing) {
        successMessage = "Keyword updated successfully";
      } else if (keywordCount > 1) {
        successMessage = `Keyword group with ${keywordCount} terms added successfully`;
      } else {
        successMessage = "Keyword added successfully";
      }

      setNotification({
        open: true,
        message: successMessage,
        severity: "success",
      });
      setFormOpen(false);
    } catch (err) {
      setNotification({
        open: true,
        message: `Failed to ${
          isEditing ? "update" : "add"
        } keyword. Please try again. Error: ${err.message || 'Unknown error'}`,
        severity: "error",
      });
      console.error(`Error ${isEditing ? "updating" : "adding"} keyword:`, err);
    } finally {
      setLoading(false);
    }
  };

  // Confirm delete
  const confirmDelete = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      await deleteKeyword(keywordToDelete, token);

      // Refresh the keywords list
      await fetchKeywords();

      setNotification({
        open: true,
        message: "Keyword deleted successfully",
        severity: "success",
      });
    } catch (err) {
      setNotification({
        open: true,
        message: "Failed to delete keyword. Please try again.",
        severity: "error",
      });
      console.error("Error deleting keyword:", err);
    } finally {
      setLoading(false);
      setDeleteDialogOpen(false);
    }
  };

  // Close notification
  const handleCloseNotification = () => {
    setNotification({
      ...notification,
      open: false,
    });
  };

  return (
    <Box>
      {/* Header and Actions */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h6" sx={{fontSize:"0.9rem"}}>Twitter Keywords Management</Typography>
        <Box sx={{ display: "flex", gap: 2 }}>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleAddKeyword}
            sx={{backgroundColor:"#4D99A3",border:"none"}}
          >
            Add Keyword
          </Button>
         
        </Box>
      </Box>

      {/* Account Selection */}
      <Paper sx={{ p: 2, mb: 3 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={3}>
            <Typography variant="subtitle1" fontWeight="bold" sx={{fontSize:"0.9rem"}}>
              Select Twitter Account:
            </Typography>
          </Grid>
          <Grid item xs={12} sm={9}>
            <FormControl fullWidth size="small">
              <Select
                value={selectedAccount || ""}
                onChange={(e) => handleAccountChange(e.target.value)}
                displayEmpty
                sx={{ minWidth: 250 }}
              >
                <MenuItem value="" sx={{fontSize:"0.9rem"}}>
                  <em sx={{fontSize:"0.9rem"}}>All Accounts</em>
                </MenuItem>
                {twitterAccounts.map((account) => (
                  <MenuItem key={account.id} value={account.id}>
                    {`${account.accountName}`}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Paper>

      {/* Inline Filters */}
      <Paper sx={{ p: 0.5, mb: 3 }}>
        <Grid container spacing={0.5} alignItems="center">
          
          <Grid item xs={12} sm={2.1}>
            <TextField
              name="text"
              label="Keyword"
              value={filters.text}
              onChange={handleFilterChange}
              fullWidth
              size="small"
              margin="dense"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon fontSize="small" />
                  </InputAdornment>
                ),
                style: { fontSize: "0.8rem" },
              }}
              InputLabelProps={{
                style: { fontSize: "0.8rem" },
              }}
            />
          </Grid>
          <Grid item xs={12} sm={1.8}>
            <TextField
              name="minLikes"
              label="Min Likes"
              type="number"
              value={filters.minLikes}
              onChange={handleFilterChange}
              fullWidth
              size="small"
              margin="dense"
              InputProps={{
                inputProps: { min: 0 },
                style: { fontSize: "0.8rem" },
              }}
              InputLabelProps={{
                style: { fontSize: "0.8rem" },
              }}
            />
          </Grid>
          <Grid item xs={12} sm={1.8}>
            <TextField
              name="minRetweets"
              label="Min RT"
              type="number"
              value={filters.minRetweets}
              onChange={handleFilterChange}
              fullWidth
              size="small"
              margin="dense"
              InputProps={{
                inputProps: { min: 0 },
                style: { fontSize: "0.8rem" },
              }}
              InputLabelProps={{
                style: { fontSize: "0.8rem" },
              }}
            />
          </Grid>
          <Grid item xs={12} sm={1.8}>
            <TextField
              name="minFollowers"
              label="Min Followers"
              type="number"
              value={filters.minFollowers}
              onChange={handleFilterChange}
              fullWidth
              size="small"
              margin="dense"
              InputProps={{
                inputProps: { min: 0 },
                style: { fontSize: "0.8rem" },
              }}
              InputLabelProps={{
                style: { fontSize: "0.8rem" },
              }}
            />
          </Grid>
          <Grid item xs={6} sm={0.9}>
            <Tooltip title="Clear filters">
              <IconButton
                onClick={clearFilters}
                size="small"
                sx={{
                  width: "28px",
                  height: "28px",
                  ml: 0.5,
                }}
              >
                <ClearIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Grid>
          <Grid item xs={6} sm={0.9}>
            <Button
              onClick={applyFilters}
              variant="contained"
              disabled={loading}
              startIcon={<FilterIcon sx={{ fontSize: "0.8rem" }} />}
              size="small"
              sx={{
                minWidth: "28px",
                height: "28px",
                border:"none",
                backgroundColor: "#4D99A3",
                fontSize: "0.7rem",
                py: 0,
                px: 1,
              }}
            >
              Filter
            </Button>
          </Grid>
        </Grid>
      </Paper>

      {/* Error Alert */}
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      {/* Keywords Table */}
      <TableContainer component={Paper} sx={{ mb: 4 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Keyword</TableCell>
              <TableCell>Account</TableCell>
              <TableCell align="right">Min Likes</TableCell>
              <TableCell align="right">Min Retweets</TableCell>
              <TableCell align="right">Min Followers</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  <CircularProgress size={24} sx={{ my: 2 }} />
                </TableCell>
              </TableRow>
            ) : keywords.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ py: 2 }}
                  >
                    No keywords found. Add a new keyword to get started.
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              keywords.map((keyword) => (
                <TableRow key={keyword.id}>
                  <TableCell>
                    {keyword.text.includes(',') ? (
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Typography variant="body2" sx={{ mr: 1 }}>
                          {keyword.text}
                        </Typography>
                        <Tooltip title="This is a group of keywords that will be searched together">
                          <Chip
                            label="Group"
                            size="small"
                            sx={{
                              height: 20,
                              fontSize: '0.65rem',
                              backgroundColor: 'rgba(72, 150, 160, 0.1)',
                              border: '1px solid rgba(72, 150, 160, 0.5)',
                              color: '#4896A0'
                            }}
                          />
                        </Tooltip>
                      </Box>
                    ) : (
                      keyword.text
                    )}
                  </TableCell>
                  <TableCell>
                    {keyword.accountId ?
                      `${keyword.accountName}` :
                      <em>Default (All Accounts)</em>
                    }
                  </TableCell>
                  <TableCell align="right">{keyword.minLikes}</TableCell>
                  <TableCell align="right">{keyword.minRetweets}</TableCell>
                  <TableCell align="right">{keyword.minFollowers}</TableCell>
                  <TableCell align="center">
                    <Tooltip title="Edit">
                      <IconButton
                        size="small"
                        onClick={() => handleEditKeyword(keyword)}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete">
                      <IconButton
                        size="small"
                        onClick={() => handleDeleteClick(keyword.id)}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                   <Tooltip title="Manage Prompt">
  <IconButton
    size="small"
    onClick={async () => {
      // Set the current keyword and open the dialog immediately for better UI feedback
      setKeywordForPrompt(keyword);
      setPromptManagementOpen(true);

      try {
        // 1. FETCH SAVED SETTINGS FROM YOUR API ENDPOINT
        const response = await axios.get(`${API_BASE_URL}/prompts/keyword/${keyword.text}`);

        // 2. CHECK IF A SAVED PROMPT WAS FOUND
        if (response.data && response.data.data) {
          const savedSettings = response.data.data;
          console.log("Fetched saved settings:", savedSettings);

          // 3. UPDATE THE STATE WITH DATABASE VALUES
          setEditedPreviewContent(savedSettings.content);
          setSelectedModel(savedSettings.model);

          // This is the key fix: Update the switch state based on the DB value
          setIsFilteringEnabled(savedSettings.isaifilteringenabled);

          // (Optional) Update the filter checkboxes based on the saved text
          const fetchedRules = savedSettings.filtrationPrompt || "";
          setFilterOptions({
            excludePromotional: fetchedRules.includes("promotional content"),
            excludeWithLinks: fetchedRules.includes("external links"),
            enableCustomRule: false,
            customRuleText: "",
          });
          
          setIsPreviewEdited(true);

        } else {
          // 4. FALLBACK TO DEFAULTS IF NO PROMPT IS SAVED
          console.log("No saved prompt found. Using default settings.");
          await fetchAllPrompts();
          setDefaultPromptForKeyword();
          setIsFilteringEnabled(false); // Ensure switch is off for defaults
        }
      } catch (error) {
        console.error("Failed to fetch prompt settings, using defaults.", error);
        // Also fallback to defaults if the API call fails
        await fetchAllPrompts();
        setDefaultPromptForKeyword();
        setIsFilteringEnabled(false);
      }
    }}
  >
    <SmartToyIcon fontSize="small" />
  </IconButton>
</Tooltip>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Add/Edit Keyword Form Dialog */}
      <Dialog
        open={formOpen}
        onClose={() => setFormOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          {isEditing ? "Edit Keyword" : "Add New Keyword"}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            {/* Keyword Text - Full width */}
            <Grid item xs={12}>
              <TextField
                name="text"
                label="Keyword Text"
                value={currentKeyword.text}
                onChange={handleInputChange}
                fullWidth
                required
                placeholder={!isEditing ? "e.g., AI, artificial intelligence, machine learning" : ""}
                helperText={
                  !isEditing ? (
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography variant="caption">
                        You can enter multiple keywords separated by commas - they will be treated as a
                      </Typography>
                      <Tooltip title="Keywords in a group will be searched together and shown as a single entity">
                        <Chip
                          label="group"
                          size="small"
                          sx={{
                            mx: 0.5,
                            height: 20,
                            fontSize: '0.7rem',
                            backgroundColor: 'rgba(72, 150, 160, 0.1)',
                            border: '1px solid rgba(72, 150, 160, 0.5)',
                            color: '#4896A0'
                          }}
                        />
                      </Tooltip>
                    </Box>
                  ) : ""
                }
              />
            </Grid>
            
            {/* Minimum Likes */}
            <Grid item xs={12} sm={4}>
              <TextField
                name="minLikes"
                label="Minimum Likes"
                type="number"
                value={currentKeyword.minLikes}
                onChange={handleInputChange}
                fullWidth
                InputProps={{ inputProps: { min: 0 } }}
              />
            </Grid>
            
            {/* Minimum Retweets */}
            <Grid item xs={12} sm={4}>
              <TextField
                name="minRetweets"
                label="Minimum Retweets"
                type="number"
                value={currentKeyword.minRetweets}
                onChange={handleInputChange}
                fullWidth
                InputProps={{ inputProps: { min: 0 } }}
              />
            </Grid>
            
           
           
                         <FormControl sx={{width:"50%"}} size="small" >

                <InputLabel id="account-select-label">Twitter Account</InputLabel>
                <Select
                  labelId="account-select-label"
                  id="account-select"
                  name="accountId"
                  value={currentKeyword.accountId || ""}
                  onChange={handleInputChange}
                  label="Twitter Account"
                >
                  <MenuItem value="">
                    <em>(All Accounts)</em>
                  </MenuItem>
                  {twitterAccounts.map((account) => (
                    <MenuItem key={account.id} value={account.id}>
                      {`${account.accountName}`}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            
          </Grid>
           
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setFormOpen(false)}>Cancel</Button>
          <Button onClick={handleSubmit} variant="contained" disabled={loading}>
            {loading ? (
              <CircularProgress size={24} />
            ) : isEditing ? (
              "Update"
            ) : (
              "Add"
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
      >
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this keyword? This action will soft
            delete the keyword.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)}>Cancel</Button>
          <Button onClick={confirmDelete} color="error" disabled={loading}>
            {loading ? <CircularProgress size={24} /> : "Delete"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Filter Dialog removed - filters are now inline */}

      {/* Prompt Management Dialog */}
      <Dialog
        open={promptManagementOpen}
        onClose={() => {
          setPromptManagementOpen(false);
          setIsPreviewEdited(false);
          setEditedPreviewContent("");
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ fontWeight: 600 }}>
          {keywordForPrompt
            ? `Manage AI Reply Prompt for Keyword: "${keywordForPrompt.text}"`
            : "Manage AI Reply Prompts"}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={3} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <Typography variant="subtitle1" gutterBottom>
                Select Model
              </Typography>
              <FormControl fullWidth>
                <Select
                  value={selectedModel}
                  onChange={(e) => {
                    const newSelectedModel = e.target.value;
                    setSelectedModel(newSelectedModel);
                    
                    // Update the availableModels array to track the selected model
                    const updatedModels = availableModels.map(model => ({
                      ...model,
                      selected: model.id === newSelectedModel
                    }));
                    setAvailableModels(updatedModels);
                    
                    // Don't update the prompt selection when model changes
                    // This keeps the model and prompt selections independent
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                    },
                    "& .MuiSelect-select": {
                      padding: "10px 14px",
                    },
                  }}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        maxHeight: 300,
                        "& .MuiMenuItem-root": {
                          fontSize: "0.9rem",
                          padding: "8px 16px",
                        },
                        "& .MuiMenuItem-root.Mui-selected": {
                          backgroundColor: "rgba(77, 153, 163, 0.1)",
                        },
                        "& .MuiMenuItem-root.Mui-selected:hover": {
                          backgroundColor: "rgba(77, 153, 163, 0.2)",
                        },
                      },
                    },
                  }}
                >
                  {availableModels.map((model) => (
                    <MenuItem key={model.id} value={model.id}>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                        <span>{model.name}</span>
                      </Box>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            
            <Grid item xs={12}>
              <Typography variant="subtitle1" gutterBottom>
                Select Prompt Template
              </Typography>
             
              <FormControl fullWidth>
  <Select
    value={isCustomPrompt ? "custom" : selectedPrompt}
    onChange={(e) => {
      if (e.target.value === "custom") {
        setIsCustomPrompt(true);
        setEditedPreviewContent(customPrompt);
        setIsPreviewEdited(false);
      } else {
        setIsCustomPrompt(false);
        setSelectedPrompt(e.target.value);

        const selectedPromptObj = availablePrompts.find(
          (p) => p.id === e.target.value
        );
        if (selectedPromptObj) {
          setEditedPreviewContent(selectedPromptObj.content);
          setIsPreviewEdited(false);
        }
      }
    }}
    sx={{
      "& .MuiOutlinedInput-root": {
        borderRadius: "8px",
      },
      "& .MuiSelect-select": {
        padding: "10px 14px",
      },
    }}
    MenuProps={{
      PaperProps: {
        sx: {
          maxHeight: 300,
          "& .MuiMenuItem-root": {
            fontSize: "0.9rem",
            padding: "8px 16px",
          },
          "& .MuiMenuItem-root.Mui-selected": {
            backgroundColor: "rgba(77, 153, 163, 0.1)",
          },
          "& .MuiMenuItem-root.Mui-selected:hover": {
            backgroundColor: "rgba(77, 153, 163, 0.2)",
          },
        },
      },
    }}
  >
    {/* Only Engaging Prompt */}
    <MenuItem disabled sx={{ opacity: 1, fontWeight: 600, color: '#4D99A3', fontSize: '0.85rem', py: 0.5 }}>
      Available Prompts
    </MenuItem>
    {availablePrompts.length > 0 ? (
      availablePrompts.map((prompt) => (
        <MenuItem key={prompt.id} value={prompt.id} sx={{ pl: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
            <span>{prompt.name}</span>
           
          </Box>
        </MenuItem>
      ))
    ) : (
      <MenuItem disabled>No prompts available</MenuItem>
    )}

   
  </Select>
</FormControl>

            </Grid>
            
            {isCustomPrompt && (
              <Grid item xs={12}>
                <Typography variant="subtitle1" gutterBottom>
                  Custom Prompt
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={4}
                  value={customPrompt}
                  onChange={(e) => {
                    const newValue = e.target.value;
                    setCustomPrompt(newValue);
                    setEditedPreviewContent(newValue);
                    setIsPreviewEdited(false);
                  }}
                  placeholder="Enter your custom prompt here. Use {tweetContent} as a placeholder for the tweet text."
                  helperText="Use {tweetContent} as a placeholder for the tweet text."
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                      transition: "all 0.3s",
                      fontSize: "0.95rem",
                    },
                    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "rgba(77, 153, 163, 0.5)",
                    },
                    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#4D99A3",
                    },
                    "& .MuiFormHelperText-root": {
                      fontSize: "0.8rem",
                      marginTop: "8px",
                    },
                  }}
                />
              </Grid>
            )}
            
         
          </Grid>
             <Grid item xs={12}>
              <Typography variant="subtitle1" gutterBottom>
                Preview
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
                  You can edit this preview to customize the prompt
                </Typography>
              </Typography>
              <TextField
                fullWidth
                multiline
                rows={6}
                value={editedPreviewContent}
                onChange={(e) => {
                  setEditedPreviewContent(e.target.value);
                  setIsPreviewEdited(true);
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                    backgroundColor: "rgba(77, 153, 163, 0.04)",
                    borderColor: "rgba(77, 153, 163, 0.2)",
                  },
                  "& .MuiOutlinedInput-input": {
                    whiteSpace: "pre-wrap",
                  }
                }}
              />
              {isPreviewEdited && (
                <Typography variant="caption" color="primary" sx={{ display: 'block', mt: 1 }}>
                  You've made custom edits to this prompt
                </Typography>
              )}
            </Grid>
               <Grid item xs={12} sx={{ mt: 2 }}>
                          <Typography variant="subtitle1" gutterBottom>
                            AI Post Filtering
                          </Typography>
                          <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: -1, mb: 1 }}>
                            Automatically filter out irrelevant posts using AI.
                          </Typography>
          
                          <FormControlLabel
                            control={
                              <Switch
                                checked={isFilteringEnabled}
                                onChange={(e) => setIsFilteringEnabled(e.target.checked)}
                                sx={{
                                  "& .MuiSwitch-switchBase.Mui-checked": {
                                    color: "#4D99A3",
                                  },
                                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                                    backgroundColor: "#4D99A3",
                                  },
                                }}
                              />
                            }
                            label="Enable AI Post Filtering"
                          />
          
                          {isFilteringEnabled && (
                            <Box
                              sx={{
                                mt: 2,
                                p: 2,
                                border: "1px solid rgba(0, 0, 0, 0.12)",
                                borderRadius: "8px",
                              }}
                            >
                              <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
                                Filtering Rules:
                              </Typography>
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={filterOptions.excludePromotional}
                                      onChange={(e) =>
                                        setFilterOptions({
                                          ...filterOptions,
                                          excludePromotional: e.target.checked,
                                        })
                                      }
                                    />
                                  }
                                  label="Exclude promotional content or ads"
                                />
          
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={filterOptions.excludeWithLinks}
                                      onChange={(e) =>
                                        setFilterOptions({
                                          ...filterOptions,
                                          excludeWithLinks: e.target.checked,
                                        })
                                      }
                                    />
                                  }
                                  label="Exclude posts that contain external links"
                                />
          
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={filterOptions.enableCustomRule}
                                      onChange={(e) =>
                                        setFilterOptions({
                                          ...filterOptions,
                                          enableCustomRule: e.target.checked,
                                        })
                                      }
                                    />
                                  }
                                  label="Add a custom filtering rule"
                                />
          
                                {filterOptions.enableCustomRule && (
                                  <TextField
                                    value={filterOptions.customRuleText}
                                    onChange={(e) =>
                                      setFilterOptions({
                                        ...filterOptions,
                                        customRuleText: e.target.value,
                                      })
                                    }
                                    placeholder="e.g., the post must mention AI or technology"
                                    variant="outlined"
                                    size="small"
                                    sx={{ mt: 1, ml: 4 }}
                                  />
                                )}
                              </FormGroup>
                            </Box>
                          )}
                        </Grid>
        </DialogContent>
        <DialogActions>
        
         <Button
  onClick={async () => {
    try {
      // 1. Construct the filtration prompt text from the filterOptions state
      let filtrationPromptText = "";
      if (isFilteringEnabled) {
        const rules = [];
        if (filterOptions.excludePromotional) {
          rules.push("exclude promotional content or ads");
        }
        if (filterOptions.excludeWithLinks) {
          rules.push("exclude posts that contain external links");
        }
        if (filterOptions.enableCustomRule && filterOptions.customRuleText) {
          rules.push(filterOptions.customRuleText);
        }
        if (rules.length > 0) {
          filtrationPromptText =
            "Filter the post if it meets any of the following criteria: " +
            rules.join("; ") +
            ".";
        }
      }
console.log("Constructed Filtration Prompt:", filtrationPromptText);
      // Store selected model in state
      const updatedModels = availableModels.map((model) => ({
        ...model,
        selected: model.id === selectedModel,
      }));
      setAvailableModels(updatedModels);

      // Only store custom prompt in localStorage if needed
      if (isCustomPrompt) {
        localStorage.setItem("customPrompt", customPrompt);
      }
      let promptId;

      // Always create a new prompt if the preview has been edited
      if (isPreviewEdited || isCustomPrompt) {
        const promptName = keywordForPrompt
          ? `Prompt for ${
              keywordForPrompt.text
            } (${new Date().toLocaleString()})`
          : "Custom " + new Date().toLocaleString();

        if (isCustomPrompt) {
          localStorage.setItem("customPrompt", customPrompt);
        }

        const promptData = {
          name: promptName,
          model: selectedModel,
          content: editedPreviewContent,
          // 2. Add the AI filtering data to the payload
          isAiFilteringEnabled: isFilteringEnabled,
          fillterationPrompt: filtrationPromptText,
          keywordForPrompt: keywordForPrompt.text, // Corrected typo here
          is_default: false,
        };

        if (keywordForPrompt && keywordForPrompt.id) {
          promptData.keywordIds = [keywordForPrompt.id];
        }

        const response = await axios.post(
          `${API_BASE_URL}/prompts`,
          promptData
        );
   
        promptId = response.data.data.id;
      } else {
        promptId = selectedPrompt;
        const selectedPromptObj = availablePrompts.find(
          (p) => p.id === promptId
        );

        if (selectedPromptObj) {
          const isNumericId = !isNaN(parseInt(promptId));

          if (isNumericId) {
            try {
              await axios.put(`${API_BASE_URL}/prompts/${promptId}`, {
                name: selectedPromptObj.name,
                model: selectedModel,
                content: selectedPromptObj.content,
                // 2. Also add the AI filtering data here
                isAiFilteringEnabled: isFilteringEnabled,
               fillterationPrompt: filtrationPromptText,
                is_default: selectedPromptObj.name === "Default",
              });
            } catch (error) {
              console.error("Error updating prompt:", error);
              const response = await axios.post(`${API_BASE_URL}/prompts`, {
                name: selectedPromptObj.name,
                model: selectedModel,
                content: selectedPromptObj.content,
                // 2. And here
                isAiFilteringEnabled: isFilteringEnabled,
                fillterationPrompt: filtrationPromptText,
                keywordForPrompt: keywordForPrompt.text,
                is_default: selectedPromptObj.name === "Default",
              });
              promptId = response.data.data.id;
            }
          } else {
            console.log(
              `Creating new prompt based on standard template: ${selectedPromptObj.name}`
            );
            const promptData = {
              name: selectedPromptObj.name,
              model: selectedModel,
              content: selectedPromptObj.content,
              // 2. And finally, here
              isAiFilteringEnabled: isFilteringEnabled,
              fillterationPrompt: filtrationPromptText,
              keywordForPrompt: keywordForPrompt.text,
              is_default: selectedPromptObj.name === "Default",
            };

            if (keywordForPrompt && keywordForPrompt.id) {
              promptData.keywordIds = [keywordForPrompt.id];
            }

            const response = await axios.post(
              `${API_BASE_URL}/prompts`,
              promptData
            );
            promptId = response.data.data.id;
          }
        }
      }

      // Refresh all prompts from the database
      await fetchAllPrompts();

      setPromptManagementOpen(false);
      setKeywordForPrompt(null);
      setNotification({
        open: true,
        message: keywordForPrompt
          ? `Prompt for keyword "${keywordForPrompt.text}" saved successfully`
          : "Prompt settings saved successfully",
        severity: "success",
      });
    } catch (error) {
      console.error("Error saving prompt:", error);
      setNotification({
        open: true,
        message: "Failed to save prompt settings",
        severity: "error",
      });
    }
  }}
  variant="contained"
  sx={{ backgroundColor: "#4D99A3" }}
>
  Save
</Button>
        </DialogActions>
      </Dialog>

      {/* Notification Snackbar */}
      <Snackbar
        open={notification.open}
        autoHideDuration={6000}
        onClose={handleCloseNotification}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseNotification}
          severity={notification.severity}
          sx={{ width: "100%" }}
        >
          {notification.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default TwitterKeywords;
 
 